import { Fragment, useEffect, useMemo, useState } from 'react';
import { Badge, Button } from 'react-bootstrap';
import { FaEye, FaRegEdit, FaUserSlash } from 'react-icons/fa';
import { RiFilePaperLine, RiShieldUserFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import { useDispatch, useSelector } from 'react-redux';

import { Link } from 'react-router-dom';
import {
  useAsyncDebounce,
  useExpanded,
  useFilters,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable
} from 'react-table';
import { toast } from 'react-toastify';
import DefaultColumnFilter from '../../../Components/ReactTable/Filters/DefaultColumnFilter';
import ReactTableRender from '../../../Components/ReactTable/ReactTableRender';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../_helpers/_methods';
import Buttons from './Components/Buttons';
import UserImage from '../../../Components/UserImage';
import ToolTip from '../../../Components/ToolTip';
import { useRef } from 'react';
import { checkPermission } from '../../../_helpers/roles/check-roles';
import { promoteUser } from '../../../Redux/slices/user';

// eslint-disable-next-line no-unused-vars
function Rosters({ kind, suspended, approved }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const local = useSelector((state) => state.local.local);
  const permissions = useSelector((state) => state.user.permissions);
  const [pageNum, setPageNum] = useState(1);
  const gotoPage = (page) => setPageNum(page);
  const previousPage = (page) => setPageNum(page);
  const nextPage = (page) => setPageNum(page);
  const user = useSelector((state) => state.user.user);
  const [URL, setURL] = useState('');
  const [rosterType, setRosterType] = useState('individual');
  const [loading, setLoading] = useState(false);
  const [filteredRosters, setFilteredRosters] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [nameSearch, setNameSearch] = useState('');
  const [phoneSearch, setPhoneSearch] = useState('');

  const [suspendedCount, setSuspendedCount] = useState();
  const [pendingCount, setPendingCount] = useState();

  useEffect(() => {
    getCounts();
  }, []);
  const getCounts = async () => {
    const response = await fetchWrapper.get('/dashboard');
    setSuspendedCount(response?.data?.suspended_rp);
    setPendingCount(response?.data?.unapproved_rp);
  };
  const handleSuspend = async (e, id) => {
    try {
      await fetchWrapper.get(`/profile/resource-person/${id}/suspend/`);
      toast.success(
        <div className="d-flex">
          <FormattedMessage id="resource_person" /> <FormattedMessage id="suspended_successfully" />
        </div>
      );
      dispatch(fetchRosters(URL));

      getCounts();
      navigate('/admin/rosters/individual_list');
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };
  const handleRosterEdit = async (id) => {
    navigate({ pathname: `/admin/rosters/individual/${id}/edit` });
  };

  const ManualFilterByName = ({ column: { filterValue, setFilter } }) => {
    const inputRef = useRef(null);
    const [name, setName] = useState(filterValue);
    const handleNameChange = useAsyncDebounce((value) => {
      setFilter(value || undefined);
      setNameSearch(value);
    }, 800);
    return (
      <input
        ref={inputRef}
        value={name || ''}
        onChange={(e) => {
          setName(e.target.value);
          handleNameChange(e.target.value);
        }}
        placeholder={intl.formatMessage({ id: 'filter.search' })}
      />
    );
  };

  const ManualFilterByPhone = ({ column: { filterValue, setFilter } }) => {
    const inputRef = useRef(null);
    const [phone, setPhone] = useState(filterValue);
    const handlePhoneChange = useAsyncDebounce((phone) => {
      setFilter(phone || undefined);
      setPhoneSearch(phone);
    }, 800);
    return (
      <input
        ref={inputRef}
        type="number"
        value={phone || ''}
        onChange={(e) => {
          setPhone(e.target.value);
          handlePhoneChange(e.target.value);
        }}
        placeholder={intl.formatMessage({ id: 'filter.search' })}
      />
    );
  };
  const SelectColumnFilter = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = useMemo(() => {
      const options = new Set();
      preFilteredRows.forEach((row) => {
        options.add(row.values[id]);
      });
      return [...options.values()];
    }, [id, preFilteredRows]);

    // Render a multi-select box
    return (
      <select
        value={filterValue}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}>
        <FormattedMessage id="tableSelect.all">
          {(label) => <option value="">{label[0]}</option>}
        </FormattedMessage>
        {options.map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  };

  const handleUserPromotion = (user, promotionRole) => {
    const userData = {
      fullname: user.fullname,
      email: user.email,
      phone: user.phone,
      user: user.user
    };
    dispatch(promoteUser(userData));
    navigate(`/admin/users/${promotionRole}s/new?promotion=${promotionRole}`);
  };
  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="sn" />,
        accessor: 'serial_number',
        width: '250px',
        disableFilters: true
      },
      {
        Header: <FormattedMessage id="event.fullname" />,
        accessor: 'fullname',
        Filter: ManualFilterByName,
        Cell: ({ row: { original }, cell: { value } }) => {
          return (
            <Link to={`/admin/rosters/profile/${original.more_options.id}`}>
              <span className="d-flex align-items-center ">
                <div className="me-1 position-relative">
                  <UserImage
                    avatar={original?.image}
                    userName={value}
                    userId={String(original.more_options.id)}
                  />
                  <span className="avatar-profile-iscomplete-badge">
                    {original.warnings && (
                      <ToolTip
                        warnings={original.warnings}
                        isComplete={original.is_profile_updated}
                      />
                    )}
                  </span>
                </div>

                <span className="d-block">
                  {value} <br />
                  {/* <small>({original.office_name})</small> */}
                </span>
                {original.suspended && (
                  <Badge bg="danger">
                    <FormattedMessage id="suspended" />
                  </Badge>
                )}
              </span>
            </Link>
          );
        },
        width: '200px'
      },
      {
        Header: <FormattedMessage id="address" />,
        accessor: 'address',
        width: '200px'
      },
      {
        Header: <FormattedMessage id="mobile_number" />,
        accessor: 'phone_number',
        Filter: ManualFilterByPhone,
        width: '400px'
      },
      {
        Header: <FormattedMessage id="email" />,
        accessor: 'email'
      },

      {
        Header: <FormattedMessage id="gender" />,
        accessor: 'gender',
        Filter: SelectColumnFilter,
        filter: 'equals'
      },
      {
        Header: <FormattedMessage id="qualification" />,
        accessor: 'qualification',
        width: '400px'
      },
      {
        Header: <FormattedMessage id="thematic_area" />,
        accessor: 'thematic_area',
        width: '600px'
      },
      {
        Header: <FormattedMessage id="total_training_given" />,
        accessor: 'training_given'
      },
      {
        Header: <FormattedMessage id="approved_by" />,
        disableFilters: true,
        accessor: 'approved_by'
      },
      {
        Header: <FormattedMessage id="province_priority" />,
        disableFilters: true,
        accessor: 'province_priority'
      },
      {
        Header: <FormattedMessage id="resume" />,
        accessor: 'cv_resume',
        disableFilters: true
      },

      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'more_options',
        disableFilters: true,
        Cell: ({ row: { original }, cell: { value } }) => {
          let promotionOptions = [];
          let hasExecutiveProfile = false;
          let hasCdAdminProfile = false;
          let roleArray = value.role;
          if (typeof roleArray === 'string') {
            roleArray = [roleArray];
          }
          roleArray?.forEach((role) => {
            if (role.key === 'executive') {
              hasExecutiveProfile = true;
            } else if (role.key === 'cd_admin') {
              hasCdAdminProfile = true;
            }
          });

          if (!hasExecutiveProfile) {
            promotionOptions.push('executive');
          }
          if (!hasCdAdminProfile) {
            promotionOptions.push('cd_admin');
          }
          const hasPromotionOptions = promotionOptions.length > 0;

          return (
            <div>
              <div className="d-flex justify-content-between align-items-between mx-2">
                <div className="ms-2">
                  <Link to={`/admin/rosters/profile/${value.id}`}>
                    <Button className="action-button" variant="outline-primary">
                      <FaEye />
                    </Button>
                  </Link>

                  {/* </Link> */}
                </div>
                {permissions['Can change resource person'] && (
                  <>
                    <div className="ms-2">
                      <Button
                        className="action-button"
                        variant="outline-secondary"
                        onClick={() => handleRosterEdit(value.id)}>
                        <FaRegEdit />
                      </Button>
                    </div>
                    <div className="ms-2">
                      <Link to={'/admin/rosters/individual_list'}>
                        <Button
                          className="action-button"
                          variant="outline-danger"
                          onClick={(e) => handleSuspend(e, value.id)}>
                          <FaUserSlash />
                        </Button>
                      </Link>
                    </div>
                  </>
                )}
              </div>
              {checkPermission(user.active_role, 'Can promote') && hasPromotionOptions && (
                <div className="d-flex flex-column">
                  {promotionOptions.map((option) => (
                    <Button
                      variant={option === 'executive' ? 'outline-danger' : 'outline-primary'}
                      className="mt-2"
                      key={option}
                      onClick={() => handleUserPromotion(original.more_options, option)}>
                      <FormattedMessage id={`promote-${option}`} />
                    </Button>
                  ))}
                </div>
              )}
            </div>
          );
        }
      }
    ],
    [permissions, local, user]
  );
  const data = useMemo(() => {
    if (Array.isArray(filteredRosters)) {
      let count = (pageNum - 1) * 50 + 1;
      return filteredRosters?.map((result) => {
        let priority = (
          <div>
            {result?.priorities?.map((priority, index) => (
              <p className="w-max-content" key={index}>
                {priority}
              </p>
            ))}
          </div>
        );
        let Thematic_Area =
          local === 'en' ? result.thematic_area?.en.join() : result.thematic_area?.np.join();
        let qualification = '';
        result.qualifications?.map((item) => {
          qualification += `${item.level} in ${item.sector}, `;
        });
        let resume = (
          <div>
            {result.resume ? (
              <Button
                variant="outline-secondary"
                onClick={() => window.open(`${result?.resume}`, '_blank')}>
                <div>
                  <RiFilePaperLine />
                </div>
              </Button>
            ) : (
              'N/A'
            )}
          </div>
        );
        return {
          serial_number: count++,
          fullname: result.fullname,
          email: result.email,
          gender: intl.formatMessage({ id: result.gender || 'p' }),
          phone_number: result.phone,
          address: result.address,
          image: result?.image,
          qualification: qualification,
          thematic_area: Thematic_Area,
          training_given: result.training_given,
          approved_by: result.approved_by?.user,
          province_priority: priority,
          warnings: result.warnings,
          is_profile_updated: result.is_profile_updated,
          cv_resume: resume,
          more_options: result,
          role: result.role
        };
      });
    } else {
      return [];
    }
  }, [filteredRosters]);

  const defaultColumn = useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }),
    []
  );

  const {
    headerGroups,
    getTableProps,
    getTableBodyProps,
    page,
    prepareRow,
    visibleColumns,
    setPageSize,
    state: { pageSize, pageIndex }
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 50 },
      manualPagination: true,
      defaultCanFilter: true,
      defaultColumn
    },
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const paramsGenerator = () => {
    let params = '';
    params += `&type=${rosterType}`;
    if (pageSize) {
      params += `&limit=${pageSize}`;
    }
    if (pageNum) {
      params += `&offset=${(pageNum - 1) * pageSize}&page=${pageNum}`;
    }
    if (nameSearch) {
      params += `&fullname=${nameSearch}`;
    }
    if (phoneSearch) {
      params += `&phone=${phoneSearch}`;
    }
    return params;
  };

  useEffect(() => {
    let url = '/profile/resource-person/?approved=true&suspended=false&active_role=resource_person';

    let params = paramsGenerator();
    setURL(`${url}${params}`);
  }, [pageSize, pageNum, nameSearch, phoneSearch, rosterType]);

  const fetchRosters = async () => {
    try {
      setLoading(true);
      const response = await fetchWrapper.get(URL);
      setTotalCount(response.data.count);
      setFilteredRosters(response.data.results);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      ErrorMessageHandler(error);
    }
  };

  useEffect(() => {
    if (URL) fetchRosters();
  }, [URL]);

  const pageCountArray = useMemo(
    () => Array.from({ length: Math.ceil(totalCount / pageSize) }, (v, i) => i + 1),
    [totalCount, pageSize]
  );
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between">
        <div className="d-flex">
          <h3 className=" text-primary d-inline-block">
            <RiShieldUserFill size={32} className="me-2" />
            <FormattedMessage id="approved_roster" />
            <Badge bg="danger" className="ms-2">
              {totalCount}
            </Badge>
          </h3>
          <div className="nav mr-auto ms-4">
            <Button
              variant={`btn ${rosterType === 'individual' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setRosterType('individual')}>
              <FormattedMessage id="individual" />
            </Button>
            <Button
              variant={`btn ${rosterType === 'department' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setRosterType('department')}
              className="ms-2">
              <FormattedMessage id="organization" />
            </Button>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-end">
          <Buttons suspendedCount={suspendedCount} pendingCount={pendingCount} />
        </div>
      </div>
      <div className="card-body event-wrapper pt-0">
        <ReactTableRender
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          totalCount={totalCount}
          gotoPage={gotoPage}
          previousPage={previousPage}
          pageCount={pageCountArray?.length}
          pagination={true}
          pageCountArray={pageCountArray}
          pageNum={pageNum}
          showGoto={true}
          nextPage={nextPage}
          pageIndex={pageIndex}
          canNextPage={pageNum < pageCountArray?.length}
          canPreviousPage={pageNum > 1}
          loading={loading}
          visibleColumns={visibleColumns}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
}

export default Rosters;
